/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as AuthedQuestionsRouteImport } from './routes/_authed.questions'
import { Route as AuthedProfileRouteImport } from './routes/_authed.profile'
import { Route as AuthedMatchesRouteImport } from './routes/_authed.matches'
import { Route as AuthedLoopsRouteImport } from './routes/_authed.loops'
import { Route as AuthedDashboardRouteImport } from './routes/_authed.dashboard'
import { Route as AuthedCvRouteImport } from './routes/_authed.cv'
import { Route as AuthedCoverLettersRouteImport } from './routes/_authed.cover-letters'
import { Route as AuthedApplicationsRouteImport } from './routes/_authed.applications'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQuestionsRoute = AuthedQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMatchesRoute = AuthedMatchesRouteImport.update({
  id: '/matches',
  path: '/matches',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLoopsRoute = AuthedLoopsRouteImport.update({
  id: '/loops',
  path: '/loops',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCvRoute = AuthedCvRouteImport.update({
  id: '/cv',
  path: '/cv',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCoverLettersRoute = AuthedCoverLettersRouteImport.update({
  id: '/cover-letters',
  path: '/cover-letters',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedApplicationsRoute = AuthedApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/applications': typeof AuthedApplicationsRoute
  '/cover-letters': typeof AuthedCoverLettersRoute
  '/cv': typeof AuthedCvRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/loops': typeof AuthedLoopsRoute
  '/matches': typeof AuthedMatchesRoute
  '/profile': typeof AuthedProfileRoute
  '/questions': typeof AuthedQuestionsRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/applications': typeof AuthedApplicationsRoute
  '/cover-letters': typeof AuthedCoverLettersRoute
  '/cv': typeof AuthedCvRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/loops': typeof AuthedLoopsRoute
  '/matches': typeof AuthedMatchesRoute
  '/profile': typeof AuthedProfileRoute
  '/questions': typeof AuthedQuestionsRoute
  '/': typeof AuthedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_authed/applications': typeof AuthedApplicationsRoute
  '/_authed/cover-letters': typeof AuthedCoverLettersRoute
  '/_authed/cv': typeof AuthedCvRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/loops': typeof AuthedLoopsRoute
  '/_authed/matches': typeof AuthedMatchesRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/questions': typeof AuthedQuestionsRoute
  '/_authed/': typeof AuthedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/applications'
    | '/cover-letters'
    | '/cv'
    | '/dashboard'
    | '/loops'
    | '/matches'
    | '/profile'
    | '/questions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/applications'
    | '/cover-letters'
    | '/cv'
    | '/dashboard'
    | '/loops'
    | '/matches'
    | '/profile'
    | '/questions'
    | '/'
  id:
    | '__root__'
    | '/_authed'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/_authed/applications'
    | '/_authed/cover-letters'
    | '/_authed/cv'
    | '/_authed/dashboard'
    | '/_authed/loops'
    | '/_authed/matches'
    | '/_authed/profile'
    | '/_authed/questions'
    | '/_authed/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/questions': {
      id: '/_authed/questions'
      path: '/questions'
      fullPath: '/questions'
      preLoaderRoute: typeof AuthedQuestionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/matches': {
      id: '/_authed/matches'
      path: '/matches'
      fullPath: '/matches'
      preLoaderRoute: typeof AuthedMatchesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/loops': {
      id: '/_authed/loops'
      path: '/loops'
      fullPath: '/loops'
      preLoaderRoute: typeof AuthedLoopsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cv': {
      id: '/_authed/cv'
      path: '/cv'
      fullPath: '/cv'
      preLoaderRoute: typeof AuthedCvRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cover-letters': {
      id: '/_authed/cover-letters'
      path: '/cover-letters'
      fullPath: '/cover-letters'
      preLoaderRoute: typeof AuthedCoverLettersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/applications': {
      id: '/_authed/applications'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof AuthedApplicationsRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedApplicationsRoute: typeof AuthedApplicationsRoute
  AuthedCoverLettersRoute: typeof AuthedCoverLettersRoute
  AuthedCvRoute: typeof AuthedCvRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedLoopsRoute: typeof AuthedLoopsRoute
  AuthedMatchesRoute: typeof AuthedMatchesRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedQuestionsRoute: typeof AuthedQuestionsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedApplicationsRoute: AuthedApplicationsRoute,
  AuthedCoverLettersRoute: AuthedCoverLettersRoute,
  AuthedCvRoute: AuthedCvRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedLoopsRoute: AuthedLoopsRoute,
  AuthedMatchesRoute: AuthedMatchesRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedQuestionsRoute: AuthedQuestionsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
